import React, { Component } from 'react';
import Cognito from "src/js/Cognito.js";
import Api from 'src/js/Api.js';
import { Route, Switch } from 'react-router-dom';
import TripMap from 'src/component/TripReportDetail/TripMap';
import ScoreChart from 'src/component/Util/ScoreChart';
import CarScoreInfo from 'src/component/Util/CarScoreInfo'
import { Row, Col, Button } from 'react-bootstrap';
import S3 from 'src/js/S3.js';
import Modal from 'src/js/Modal.js'
import ApiErrorModal from 'src/js/ApiErrorModal.js';
import Config from 'src/config.json';
import 'src/css/TripReportDetail.css'
import 'src/i18n';
import { withTranslation } from 'react-i18next';


class TripReportDetail extends Component {

  constructor() {
    super();
    this.state = {
      // ログイン中ユーザ
      cognitoUser: [],
      // ログイン者のsub
      sub:'',
      // 車両のカープレートNO
      carPlateNo: '', 
      // ダウンロードID(ルートファイル識別用)
      downloadId: '',
      // トリップ一覧で選択されたトリップの開始時間
      startTime: '',
      // スコア
      scoreData: 0,
      // イベント日次
      eventDate: '',
      // 走行距離
      duration: 0,
      // 距離
      distance: 0,
      // トリップ詳細データ
      tripDetailData: [],
      // トリップ詳細取得フラグ
      isTripDetail: true,
      // トリップ詳細ローディング
      tripDetailLoading: false,

      // イベント詳細データ
      eventDetail: [],
      // 地図取得フラグ
      isTripMap: true,
      // 地図ローディング
      tripMapLoading: false,
    
      modalApiPath: "",
      modalStatusCode: "",
      modalErrorMessage: "",
      modalApiMessage: "",
    }

    this.getTripDetail = this.getTripDetail.bind(this);
    this.getTripMap = this.getTripMap.bind(this);
    this.getLocalStorageData = this.getLocalStorageData.bind(this);
    // this.createChartData = this.createChartData.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
  }

  componentWillMount() {
    // 認証チェック
    if (Cognito.signInCheck()) {
      // ユーザを取得
      this.setState({ cognitoUser: Cognito.getCognitoUser() });
    }
    // 描画前にローカルストレージからデータを取得する
    this.getLocalStorageData();
  }

  componentDidMount() {
    // ページの一番上までスクロール
    window.scrollTo(0, 0);
    this.getTripDetail();
  }

  handleHideModal() {
    this.setState({ showModal: false })
  }

  handleShowModal() {
    this.setState({ showModal: true })
  }

  // ローカルストレージの値を取得
  getLocalStorageData() {
    // サブ情報
    let sub = localStorage.getItem('sub');
    if (sub) {
      this.setState({
        sub: sub
      });
    }

    // カープレートNO
    let carPlateNo = localStorage.getItem('carPlate');
    if (carPlateNo) {
      this.setState({
        carPlateNo: carPlateNo,
        carInfoLoading: true,
        isCarInfo: true
      });
    }

    let downloadId = localStorage.getItem('downloadId');
    if(downloadId){
      this.setState({
        downloadId: downloadId
      })
    }

    // スタートタイム
    let startTime = localStorage.getItem('startTime');
    if (startTime) {
      this.setState({
        startTime: startTime
      });
    }
  }

  // トリップ詳細を取得する
  getTripDetail() {
    // subかstartTimeが無い場合は失敗とする
    if (!this.state.sub || !this.state.startTime) {
      this.setState({
        isTripDetail: false,
        tripDetailLoading: false
      });
      return;
    }

    let _this = this;

    _this.setState({
      isTripDetail: true,
      tripDetailLoading: true,
    });

    let queryParams = {
      startTime: this.state.startTime,
      sub: this.state.sub
    };

    // APIの実行
    // TODO: Cornering_countの項目を追加する必要あり。APIの仕様に合わせて受け取るパラメータを変化させる。
    Api.runApi(this.state.cognitoUser, Config.API.STAGE + Config.API.TRIP_REPORT_DETAIL.TRIP_DETAIL_DATA_PATH, queryParams)
      .then(function onFulfilled(result) {
        const tripDetailData = [
          { "name" : "HB 5 stars rating", "value" : result.data[0].harshBrakingEval ? result.data[0].harshBrakingEval : 0 },
          { "name" : "HA 5 stars rating", "value": result.data[0].harshAccelerationEval ? result.data[0].harshAccelerationEval : 0 },
          { "name" : "CR 5 stars rating", "value": result.data[0].corneringEval ? result.data[0].corneringEval : 0},
          { "name" : "Date", "value" : result.data[0].date },
          { "name" : "Distance", "value": result.data[0].distance ? result.data[0].distance : 0 },
          { "name" : "Duration", "value":  result.data[0].duration ? result.data[0].duration : 0 }
        ];

        let min = result.data[0].duration ? Math.round((result.data[0].duration % 60 ) * 10) / 10 : 0;
        let hour = result.data[0].duration ? parseInt((result.data[0].duration - min) / 60, 10) : 0;

        _this.setState({
          eventDate: result.data[0].date,
          duration: result.data[0].duration ? result.data[0].duration : 0,
          durationMin: min,
          durationHour: hour,
          distance: result.data[0].distance ? result.data[0].distance : 0,
          scoreData: result.data[0].tripScore ? result.data[0].tripScore : 0,
          tripDetailData: tripDetailData,
          tripDetailLoading: false
        });
      })
      .catch(function onRejected(err) {
        console.log(err);
        _this.setState({
          isTripDetail: false,
          tripDetailLoading: false,
          showModal: true,
          modalErrorMessage: "TripDetailApiError",
          modalApiPath: err.response && err.response.request.responseURL,
          modalStatusCode: err.response && err.response.status,
          modalApiMessage: err.response && err.response.data.errorMessage,
          error: !err.response && err
        });
        return;
      });
  }

  // 地図データをS3から取得する
  getTripMap(sub, startTime, callback) {
    let _this = this;

    _this.setState({
      tripMapLoading: true,
    });

    let queryParams = {
      startTime: startTime,
      sub: sub
    };

    // APIの実行
    Api.runApi(this.state.cognitoUser, Config.API.STAGE + Config.API.TRIP_REPORT_DETAIL.TRIP_MAP_PATH, queryParams)
      .then(function onFulfilled(result) {
        // ここで、tripファイルとrouteファイルとの処理を分ける
          S3.downloadPresignedUrlObject(result.data)
          .then(function onFulfilled(data){
            if(data === null){
              _this.setState({
                isTripMap: false,
                tripMapLoading: false
              })
              return
            }
            /**
             * データの受け入れ元を基に、地図表示に使用するデータの切り分けを行う
             */
            if (_this.state.downloadId == 0){
              if(data.DriveDetail == null || data.EventDetail == null){
                _this.setState({
                  isTripMap: false,
                  tripMapLoading: false
                })
                return
              }
              let DetailDatas = [data.DriveDetail, data.EventDetail]
              callback(DetailDatas)
            }
            else if (_this.state.downloadId == 1){
              if(data.map == null){
                _this.setState({
                  isTripMap: false,
                  tripMapLoading: false
                })
                return
              }
              callback(data.map)
            }
          }).then(function (){
            _this.setState({
              tripMapLoading: false
            });
          })
      })
      .catch(function onRejected(err) {
        _this.setState({
          isTripMap: false,
          tripMapLoading: false,
          showModal: true,
          modalErrorMessage: "TripMapApiError",
          modalApiPath: err.response && err.response.request.responseURL,
          modalStatusCode: err.response && err.response.status,
          modalApiMessage: err.response && err.response.data.errorMessage
        })
        console.log(err);
        return;
      });
  }

  render() {
    const {t} = this.props;

    if (this.state.error) {
      throw new Error(this.state.error);
    }

    const BackButton = () => (
      <Row>
        <Col md={12} sm={12} xs={12}>
          <Button bsStyle="link" onClick={() => {
            this.setState({
              isLink: false
            })
            localStorage.setItem('isBack', true);
            this.props.history.goBack();
          }} className="backButton">&lt;&lt;Back</Button>
        </Col>
      </Row>
    );

    return (
      <div>
        <Modal isAospBrowser={false} isLocalStorage={true} />
        <Switch>
          {/* トリップレポート詳細画面 */}
          <Route exact path="/trip_report/detail">
            <div>
              {this.state.showModal && (
                <ApiErrorModal
                  handleHideModal={this.handleHideModal}
                  modalErrorMessage={this.state.modalErrorMessage}
                  modalApiPath={this.state.modalApiPath}
                  modalStatusCode={this.state.modalStatusCode}
                  modalApiMessage={this.state.modalApiMessage}
                />
              )}
              <BackButton />
                <Row className="parentchart" id="score-grid">
                  <Col className="charttest" id="daughnut-chart">
                    <div>{this.state.eventDate}</div>
                    <div className="mini-div" />
                    <div>{t('Common.Score')}</div>
                    <ScoreChart scoreData={this.state.scoreData} isData={this.state.isTripDetail} loading={this.state.tripDetailLoading} />
                  </Col>
                  <Col className="charttest" id="star-rating">
                    <CarScoreInfo carPlateNo={this.state.carPlateNo} carOtherInfo={this.state.tripDetailData} isData={this.state.isTripDetail} loading={this.state.tripDetailLoading} />
                  </Col>
                </Row>
                <Row id="scores">
                  <Col md={6} sm={6} xs={6}>  
                    <div>
                      {t('Common.Distance')} <br/>
                      {this.state.distance}
                    </div>
                  </Col>
                  <Col md={6} sm={6} xs={6}>
                    <div>
                      {t('TripDetail.Duration')} <br/>
                      {this.state.durationHour}hrs {this.state.durationMin}mins
                    </div>
                  </Col>
                </Row>
                <div className="short-div"></div>
                <Col md={12} sm={12} xs={12}>
                  <TripMap 
                    startTime={this.state.startTime}
                    sub={this.state.sub}
                    downloadId={this.state.downloadId}
                    getTripMap={this.getTripMap} 
                    isTripMap={this.state.isTripMap} 
                    tripMapLoading={this.state.tripMapLoading}
                    />
                </Col>
            </div>
          </Route>
        </Switch>
      </div >
    );
  }
}

export default withTranslation()(TripReportDetail);



// WEBPACK FOOTER //
// ./src/component/TripReportDetail/TripReportDetail.js